import { render, staticRenderFns } from "./PlaylistItem.vue?vue&type=template&id=128ebc31&scoped=true&"
import script from "./PlaylistItem.vue?vue&type=script&lang=js&"
export * from "./PlaylistItem.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistItem.vue?vue&type=style&index=0&id=128ebc31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ebc31",
  null
  
)

export default component.exports